import { render, staticRenderFns } from "./RecipePrint.vue?vue&type=template&id=2cd9cc9e&scoped=true&lang=pug"
import script from "./RecipePrint.vue?vue&type=script&lang=js"
export * from "./RecipePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd9cc9e",
  null
  
)

export default component.exports